import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
  min-width: 482px;
`

export const BillingInfoContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-self: stretch;
`
